module.exports = __webpack_public_path__ + "static/media/eWork Experience.7caac85d.pdf";